import React, { useState } from "react";
import ActivityCreateForm from "../components/ActivityCreateForm";
import UpdateStock from "../../Stock/containers/UpdateStock.jsx"
import { getUser } from "../../auth";

const URL = process.env.REACT_APP_API_URL;

export default function ActivityCreate({ empresaNombre, empresa, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    title: "",
    operation: "",
    description: "",
    amount: "",
  });
  const [message, setMessage] = useState("");
  const [openStockModal, setOpenStockModal] = useState(false);

  const handleChange = (field) => (e) =>
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));

  const handleReset = () => {
    setFormData({ title: "", operation: "", description: "", amount: "" });
    setMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { title, operation, description, amount } = formData;

    if (!title || !operation || !amount) {
      setMessage("Algunos campos son obligatorios");
      return;
    }
    
    const user = getUser();
    const activityData = {
      empresa_id: user?.empresa_id,
      title,
      operation,
      description,
      amount: Number(amount),
    };

    try {
      const response = await fetch(`${URL}/api/activity/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Empresa-Id": user?.empresa_id,
        },
        body: JSON.stringify(activityData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setMessage(errorData.detail || "Error al crear la actividad");
      } else {
        setMessage("Actividad creada con éxito");
        handleReset();
        if (onSuccess) onSuccess(); // Por ejemplo, para recargar la tabla
        if (onClose) onClose();
      }
    } catch (error) {
      setMessage("Error en la petición. Inténtelo de nuevo.");
    }
  };

  return (
    <>
      <ActivityCreateForm
        empresaNombre={empresaNombre}
        empresa={empresa}
        form={formData}
        message={message}
        onChange={handleChange}
        onReset={handleReset}
        onClose={onClose}
        onSubmit={handleSubmit}
        onOpenStock={() => setOpenStockModal(true)}
      />

      <UpdateStock
        open={openStockModal}
        close={() => setOpenStockModal(false)}
      />

    </>
  );
}